<template>
	<div class="search-bar">
		<form class="container" autocomplete="off" action="#" @submit.prevent="submit" @reset="reset">
			<div class="searcharea">
				<input
					class="search"
					type="search"
					v-model="searchValue"
					id="AddressOrPin"
					name="AddressOrPin"
					placeholder="Enter your Address or PIN"
				/>
				<input v-if="searchValue !== ''" class="button reset" type="reset" value="X" />
			</div>
			<button class="button search-btn" type="submit" value="Search"><i class="material-icons">search</i>Search</button>
		</form>
	</div>
</template>

<script>
export default {
	name: "search-bar",
	methods: {
		submit() {
			if (this.searchValue !== "") {
				this.$store.dispatch("search/getAddressesByAny", this.searchValue);
			}
		},
		reset() {
			this.$store.commit("search/SET_DIDSEARCH", false);
			this.$store.commit("search/SET_ADDRESS", "");
		},
	},
	computed: {
		searchValue: {
			get() {
				return this.$store.state.search.searchValue;
			},
			set(v) {
				this.$store.commit("search/SET_ADDRESS", v);
			},
		},
	},
};
</script>

<style scoped lang="scss">
.search-bar {
	background-color: white;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.24);
	border-radius: 100px;
	height: 65px;
	width: 100%;
	max-width: 860px;
	margin: 0 auto;
	button.button {
		padding: 0.8rem 2.5rem;
	}
	.container {
		height: 100%;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		.searcharea {
			position: relative;
			flex-grow: 1;
			display: flex;
			align-items: center;
			.search {
				border-radius: 50px;
				flex-grow: 1;
				height: 45px;
				margin: 10px;
				display: inline-block;
				border: unset;
				border-bottom: unset;
				outline: none;
				box-sizing: border-box;
				font-family: "Poppins";
				font-size: 18px;
				padding: 0 0 0 30px;
			}
			.search::placeholder {
				font-size: 14px;
				color: var(--text);
			}
			input[type="search"]::-webkit-search-cancel-button {
				-webkit-appearance: none;
			}
			.reset {
				position: absolute;
				right: 0;
				border-radius: 50%;
				width: 40px;
				height: 40px;
				padding: 0;
				animation: slideIn 0.15s ease-in;
			}
			.reset:hover {
				cursor: pointer;
				color: white;
				background-color: #272f7c;
				filter: brightness(1.3);
			}
			input.search {
				width: 100%;
			}
			@keyframes slideIn {
				from {
					opacity: 0;
					transform: translateX(-30px);
				}
				to {
					opacity: 1;
					transform: translateX(0);
				}
			}
		}
		.search-btn {
			margin: 0 8px;
			border-radius: 100px;
			background-color: #50cdf3;
			border: unset;
			display: flex;
			flex-direction: row;
			align-items: center;
			color: var(--white);
			font-size: 14px;
			line-height: 21px;
		}
		.search-btn:hover {
			cursor: pointer;
			color: white;
			filter: brightness(0.8);
		}
	}
}
@media screen and (max-width: 414px) {
	.search-bar .container {
		display: flex;
		flex-direction: row;
		.searcharea input.search {
			padding: 0 0 0 10px;
		}
		button.button {
			padding: 0.8rem 1rem;
		}
	}
}
</style>
